<template>
  <div v-if="!show" class="ui active loader"></div>
  <div v-if="show" id="contain" class="ui center aligned padding grid">
    <div class="ui field formulario">
      <div class="ui field" id="iconoPedidos">
        <i class="ui huge shopping basket icon"></i>
        <h3>Pedidos</h3>
      </div>
      <div v-for="servicio in servicios" v-bind:key="servicio.value">
        <div class="botonera">
          <button class="ui fluid large teal button hapiick" id="idBtnServicio" v-on:click="selectedService(servicio)">
            {{ servicio.text }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuService",
  data() {
    return {
      show: false,
      msg: null,
      type: null,
      title: null,
      closeSession: 1,
      codError: null,
      servicio: null,
      sms: null,
      totalIntentos: 1,
      servicios: [],
      apm: null,
      token: null,
      virtualServiceId: null,
    };
  },

  created() {
    this.token = localStorage.token;
    this.apm = localStorage.apm;
    this.virtualServiceId = localStorage.virtualService_id;
    if (!this.token) {
      this.redirect(401,this.title,'','',this.token,this.closeSession);
    }
    this.getMenuByVirtualServices(this.apm, this.virtualServiceId);
  },
  methods: {
    getMenuByVirtualServices(apm, virtualServiceId) {
      let url = this.$url_hapiick + "/v1/apms/services/menu?apm="+apm+"&hs="+virtualServiceId;
      let headers = {
        'Content-Type': 'application/json',
        'X-Auth-Token': this.token,
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.get(url,{
        headers: headers
      })
      .then(request => {
        this.codError = request.data.error
        if (this.codError) {
          this.redirect(this.codError,this.title,'','',this.token,this.closeSession);
        } else {
          let ActiveServices = request.data.virtual_service_menu;
          if (ActiveServices.length == 1){
            this.$router.push({name:  ActiveServices[0].component, params: {apm: this.apm, token: this.token}});
          } else if (ActiveServices.length > 0) {
            for (var i = 0; i < ActiveServices.length; i++) {
              this.servicios.push({
                id: ActiveServices[i].id,
                text: ActiveServices[i].text,
                value: ActiveServices[i].key,
                key: ActiveServices[i].key,
                component: ActiveServices[i].component,
              });
            }
            this.show = true;
          } else {
            this.codError = '405';
            this.msg = '';
            this.type = '';
            this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
          }
        }
      })
      .catch((error) => {
        this.catchErrors(error);
      })
    },
    selectedService(service) {
      this.$router.push({name: service.component, params: {apm: this.apm, token: this.token}});
    },
    catchErrors(error){
      if(error.request) {
        if (error.request.status == 429) {
          this.codError = error.request.status
          this.redirect(this.codError,this.title,'','',this.token,this.closeSession);
        } else {
          console.log(error.request)
        }
      }
    },
    redirect(codError, title, msg, type, token, closeSession) {
      this.$router.push({name: "Messages", params: {codError: codError, title: title, msg: msg, type: type, token: token, closeSession: closeSession}});
    },
  },
};
</script>

<style scoped>
a {
  color: darkslategrey;
}

h3 {
  margin: 0px!important;
}

form {
  width: 100%;
}

input, button {
  height: 55px;
  font-size: 17px !important;
}

i {
  margin:0px 15px 0px 15px!important;
}

i.big.icon, i.big.icons {
  color: #696969!important;
  font-size: 2.2em!important;
  width: 50px!important;
}

#contain {
  margin: auto!important;
  width: 95%;
  height: 85%;
  position: absolute;
  top: 10%;
  left: 2.5%;
  overflow: auto;
  padding-top: 0.5em!important;
  align-items: center;
}

#iconoPedidos {
  color: darkgray!important;
  padding-bottom: 20px!important;
  margin-top: -10%!important;
}

.ui.fixed.menu + .ui.grid {
  padding-top: 0px !important;
}

.field {
  width: 100%;
}

.hapiick {
  background-color: white!important;
  border: 1px solid dimgrey!important;
  color: black !important;
}

.hapiick:hover {
  background-color: #00f9a9!important;
  border: 1px solid dimgrey!important;
}

.botonera {
  height:65px;
  display: flex;
  align-items: center;
}
</style>
